import type { TNetworkError } from '@/services/errors';
import type {
  TBookBodyDTO,
  TBookResponseDTO,
  TMemberBodyDTO,
  TMemberResponseDTO,
} from './conciergeThread.dto';

import { BaseService } from '@/services/api';
import { errorUtils } from '@/services/errors';
import { withSessionHeaders } from '@/services/supabase';

import type { TBookSync, TConciergeThread } from './conciergeThread.types';

import { toBookSync, toConciergeThread } from './conciergeThread.adapters';

const MEMBER_PATH = '/concierge-thread/member';

const BOOK_PATH = '/concierge-thread/book';

class ConciergeThreadService extends BaseService {
  protected readonly serviceName = 'conciergeThreadService';

  public async syncMember(memberID: string): Promise<TConciergeThread | null | TNetworkError> {
    const response = await this.post<TMemberResponseDTO, TMemberBodyDTO>(
      MEMBER_PATH,
      { member_id: memberID },
      { where: 'syncMember', headers: await withSessionHeaders() },
    );

    if (errorUtils.isNetworkError(response)) {
      return response;
    }

    if (!response.thread) {
      return null;
    }

    return toConciergeThread(response.thread);
  }

  public async syncBook(conciergeID: string): Promise<TBookSync | TNetworkError> {
    const response = await this.post<TBookResponseDTO, TBookBodyDTO>(
      BOOK_PATH,
      { concierge_id: conciergeID },
      { where: 'syncBook', headers: await withSessionHeaders() },
    );

    if (errorUtils.isNetworkError(response)) {
      return response;
    }

    return toBookSync(response);
  }
}

const conciergeThreadService = new ConciergeThreadService();

export {
  conciergeThreadService,
};
